import { makeAutoObservable } from 'mobx';
import { GetFieldDistinctData } from '@/presentation/components/issue-dashboard/api';
import { FieldKey } from '@/proto/field';
import { MetricType } from '@/proto/metric';

export const ALL_VERSION_NAME = '全版本';
export const appFilterOption =  (input: string, option: { value: string, label: string }|undefined) => {
  if (ALL_VERSION_NAME.indexOf(input?.toLowerCase?.()) !== -1) {
    return true;
  }
  return (option?.value ?? '')?.toLowerCase?.()?.includes?.(input?.toLowerCase?.());
};
export class OverviewStore {
  appVersionOptions: { label: string, value: string}[] = [
    { value: ALL_VERSION_NAME, label: ALL_VERSION_NAME },
  ];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async getFieldDistinctData(
    field: FieldKey,
    type: MetricType,
  ) {
    const values =  await GetFieldDistinctData(field, type);
    const options = values.map(item => ({ value: item, label: item }));
    options.unshift({ value: ALL_VERSION_NAME, label: ALL_VERSION_NAME });
    this.appVersionOptions = options;
  };
}
